module.exports = __webpack_public_path__ + "static/cc-banner-2-title-3b3f34cc8256b4ba7c8993d4e737f5aa.png";